import { render, staticRenderFns } from "./XDialog.vue?vue&type=template&id=3c4502fe&"
import script from "./XDialog.vue?vue&type=script&lang=ts&"
export * from "./XDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../tbestpro-management/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../tbestpro-management/admin-portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardActions,VCardText,VContainer,VDialog,VDivider,VSpacer,VToolbar,VToolbarTitle})
